import { PartialTheme } from "../types";
import { familyPalette, familySemanticColors, familyTheme } from "./FamilyTheme";

export const familyOnNeutralLighterAlt: PartialTheme = {
    palette: {
        ...familyTheme.palette,
        neutralMed: familyPalette.themeLighterAlt,
        white: "#ffffff"
    },
    semanticColors: {
        ...familySemanticColors,
        bodyBackground: familyPalette.themeLighterAlt
    }
};
